<template>
  <WorksWrapMain v-if="!$store.state.env.isMobile"></WorksWrapMain>
  <WorksWrapMainMobile v-else></WorksWrapMainMobile>
</template>
<script>
import WorksWrapMain from "@/components/works/WorksWrapMain";
import WorksWrapMainMobile from "@/components/works/WorksWrapMainMobile.vue";
import { mapMutations } from "vuex";
export default {
  name: "WorksWrap",
  components: {
    WorksWrapMain,
    WorksWrapMainMobile
  },
  methods: {
    ...mapMutations(["setSearchWorksType"]),
  },
  created() {
    let type = Number(this.$route.params.type)
    if(type === 0 || type === 1) {
      this.setSearchWorksType(type)
    }
    console.log(type)
  }
};
</script>
<style lang="scss" scoped>
</style>